export default "__VITE_ASSET__N8Y0qd5g__"